import readability from "readability-meter";
import pluralize from "pluralize";

async function RatingHook(str, keyWords, source = "") {
    return new Promise((res, rej) => {
        heavyDutyWorker.postMessage({
            list: keyWords?.map((item) => ({
                ...item,
                singular: pluralize.singular(item?.keyword),
                plural: pluralize.plural(item?.keyword),
            })),
            text: str,
            source,
            command: "keyTermsUsage",
        });

        const callback = ({ data }) => {
            if (data.command == "keyTermsUsage" && data.source == source) {
                const obj = {
                    readability: 0,
                    wordCount: data.noOFWords,
                    score: data.count,
                    source: data.source,
                    keyTermslist: data.list,
                };

                res(obj);
                heavyDutyWorker.removeEventListener("message", callback);
            }
        };
        heavyDutyWorker.addEventListener("message", callback);
    });
}

export default RatingHook;
